import React, { useCallback, useState } from "react";
import { useTranslations } from "@jugl-web/utils";
import { WhatsappPinDialogContent } from "../../components/WhatsappPinDialogContent";
import { WhatsappPinDialogFooter } from "../../components/WhatsappPinDialogFooter";

export const ConfirmActionScreen: React.FC<{
  verifyActionCallback?: (pin: string) => Promise<void>;
  isPinInvalid?: boolean;
}> = ({ verifyActionCallback, isPinInvalid }) => {
  const { t } = useTranslations();
  const [currentPin, setCurrentPin] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleConfirmAction = useCallback(async () => {
    setIsLoading(true);
    await verifyActionCallback?.(currentPin);
    setIsLoading(false);
  }, [currentPin, verifyActionCallback]);

  return (
    <>
      <WhatsappPinDialogContent
        title={t({
          id: "client-support-page.enter-current-pin",
          defaultMessage: "Verify Action",
        })}
        subtitle={t({
          id: "client-support-page.confirm-action-entering-pin",
          defaultMessage: "Confirm action by entering your 6-digit PIN",
        })}
        pin={currentPin}
        onPinChange={setCurrentPin}
        errorMessage={
          isPinInvalid
            ? t({
                id: "client-support-page.invalid-pin",
                defaultMessage: "Invalid PIN",
              })
            : undefined
        }
      />
      <WhatsappPinDialogFooter
        buttons={[
          {
            text: t({
              id: "common.verify",
              defaultMessage: "Verify",
            }),
            isDisabled: isLoading,
            onClick: handleConfirmAction,
          },
        ]}
      />
    </>
  );
};
